import React from 'react';
import { Grid, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import CurrencySelect from './CurrencySelect';

export default function DocumentCurrencyInput({ control, errors, watch, readOnly }) {
  return (
    <Grid display={'flex'} alignItems={'center'} gap={2}>
      {watch('document_currency_code') !== 'MYR' && 'One'}{' '}
      <Grid item size={{ xs: 12, md: 4 }}>
        <CurrencySelect control={control} errors={errors} name="document_currency_code" readOnly={readOnly} />
      </Grid>
      {watch('document_currency_code') !== 'MYR' && '='}
      {watch('document_currency_code') !== 'MYR' && (
        <Grid
          item
          size={{ xs: 12, md: 4 }}
          sx={{ minWidth: 100, marginTop: errors.conversion_rate_per_myr ? '1.5rem' : '' }}
        >
          <Controller
            name="conversion_rate_per_myr"
            control={control}
            render={({ field }) => (
              <TextField
                type="number"
                id="conversion_rate_per_myr"
                label="Conversion Rate"
                variant="outlined"
                fullWidth
                {...field}
                error={!!errors.conversion_rate_per_myr}
                helperText={errors.conversion_rate_per_myr?.message}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,8}$/.test(value)) {
                    field.onChange(value);
                  }
                }}
                slotProps={{
                  input: {
                    readOnly: readOnly,
                  },
                }}
              />
            )}
          />
        </Grid>
      )}
      {watch('document_currency_code') !== 'MYR' && 'RM'}
    </Grid>
  );
}
